import * as React from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useState, ChangeEvent } from 'react';
import { getTodaysDate, getYesterdaysDate } from '../utils/DateUtils';
import { Create, FilterLiveSearch, Form, SaveButton, useListController, useRefresh } from 'react-admin';
import moment from 'moment';
import ClientList from './clients/ClientList';
import PharmacyList from './pharmacy/PharmacyList';
import TpaFilter from './TpaFilter';
import { Search } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import WeekSelection from './WeekSelection';
import FilterHeader from './FilterHeader';
import DateRangeSelector from './DateRangeSelector';
import { ClientDataType, PharmacyDataType, TPADataType, SetDatePropsType } from '../utils/DataTypes';

import BrokerFilter from './BrokerFilter';

type FormValues = {
  search: string;
  start_date: Date;
  selectedWeek: string;
  monthYear: Date;
  pharmacies: string[];
};

const SearchFilters = ({ toggleDrawer }) => {
  const refresh = useRefresh();
  const navigate = useNavigate();
  const { setFilters } = useListController();
  const [startDate, setStartDate] = useState<string>(getYesterdaysDate);
  const [endDate, setEndDate] = useState<string>(getTodaysDate);
  const [selectedPharmacies, setPharmacies] = useState<PharmacyDataType[]>([] as PharmacyDataType[]);
  const [selectedClients, setClients] = useState<ClientDataType[]>([] as ClientDataType[]);
  const [selectedTPAs, setTPAs] = useState<TPADataType[]>([] as TPADataType[]);
  const [selectedBrokers, setBrokers] = useState<TPADataType[]>([] as TPADataType[]);
  const [toggleDateSelectionAndAssistBilling, setToggle] = useState(true);
  const methods = useForm<FormValues>({
    defaultValues: {
      search: 'test',
      start_date: new Date('01-01-2024'),
    },
  });

  // Function to update the filters
  const updateDefaultFilters = (newFilters) => {
    setFilters(newFilters, null, false);
  };

  const handleUpdateFilters = () => {
    updateDefaultFilters({ status: 'active' });
  };

  const onSubmit = (values: any) => {
    values.start_date = moment(startDate).format('YYYY-MM-DD');
    values.end_date = moment(endDate).format('YYYY-MM-DD');

    //delete values.pharmacies;

    var selectedClientNums = selectedClients.map(function (client) {
      return client.client_number;
    });

    var selectedPharamcyNpis = selectedPharmacies.map(function (pharmacy) {
      return pharmacy.pharmacy_npi;
    });

    var selectedTPAVendorNums = selectedTPAs.map(function (tpas) {
      return tpas.vendor_number;
    });

    var selectedBrokerVendorNums = selectedBrokers.map(function (brokers) {
      return brokers.vendor_number;
    });

    values.clients = selectedClientNums;
    values.pharmacies = selectedPharamcyNpis;
    values.tpas = selectedTPAVendorNums.concat(selectedBrokerVendorNums);

    setFilters(values);

    for (let key in values) {
      let value = values[key];
    }

    toggleDrawer();
  };

  const resetForm = () => {
    //document.getElementById('filterForm')?.reset();
    //reset();
    //clear;
    //useEffect(() => {
    // methods.setValue('start_date', new Date("2025-01-01"));
    //methods.setValue('q', 'testi2___>');
    methods.setValue('search', 'testi2_||__>');
    methods.setValue('start_date', new Date('2024-08-01'));
    methods.resetField('search');
    //     });

    /* reset({ q: '',
           start_date:''}) ;  
*/ // input="test";
    //setTextValue("testi___>");
    //setDateInputYesterday(new Date("2024-08-01"));
    //setDateInputYesterday(new Date("2024-01-01"));

    /*  const reference=textRef.current;
           if(reference && reference.value.length > 0){
             //reference="";
           } else{
           } */
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target) {
      setFilters({ q: event.target.value }, null, true);
    } else {
      // const { [source]: _, ...filters } = filterValues;
      //setFilters(filters);
    }
  };

  return (
    <>
      <Box sx={{ boxShadow: '1', borderRadius: 0, bgcolor: '#f4f1ec' }} border="1" marginLeft={1} marginRight={1}>
        {/*  <FilterLiveSearch  label="Search claims by client, TPA"
           placeholder="Search claims by client, TPA" fullWidth={true}
           sx={{borderRadius:10}} source="q"
           resettable={true}  variant='outlined'
           onChange={handleChange } />  */}

        <Create sx={{ boxShadow: '0' }}>
          <Form resetOptions={{ keepDirtyValues: true }} onSubmit={onSubmit}>
            <Stack
              direction="row"
              spacing={2}
              display="flex"
              sx={(theme) => ({
                boxShadow: 1,
                bgcolor: '#f4f1ec',
                p: 0,
                m: 0,
                borderRadius: 0,
                textAlign: 'left',
              })}
            >
              <Box flexGrow={1} background-color="#f4f1ec" border="none">
                <DateRangeSelector
                  setStartDateFunction={setStartDate}
                  setEndDateFunction={setEndDate}
                  setToggleFunction={setToggle}
                />
              </Box>

              {/*   <DatePicker
                                         selected={startDate}
                                         onChange={(date) => setStartDate(date)}
                                         dateFormat="MM/yyyy"
                                       
                                         showMonthYearPicker
                                        
                                       /> */}

              {/*  <Box flexGrow={1} marginTop={2} >
                                     
                                        <WeekSelection
                                         setStartDateFunction={setStartDate}
                                         setEndDateFunction={setEndDate}
                                         setToggleFunction={setToggle}
                                         source="week" label=""
                                       
                                        />
                                     
                                       </Box> */}

              <Box flexGrow={1} paddingTop={2} background-color="rgba(250, 229, 211, 1)" border="none">
                <ClientList setFunction={setClients} />
              </Box>

              <Box flexGrow={1} paddingTop={2}>
                <PharmacyList setFunction={setPharmacies} />
              </Box>
              <Divider sx={{ border: 0 }} />

              <Box flexGrow={1} paddingTop={2}>
                <TpaFilter setFunction={setTPAs} />
              </Box>

              <Divider sx={{ border: 0 }} />

              <Box flexGrow={1} paddingTop={2}>
                <BrokerFilter setFunction={setBrokers} />
              </Box>

              <Box flexGrow={1} marginBottom={8} paddingTop={2} paddingBottom={2} paddingRight={2}>
                <SaveButton
                  label={''}
                  icon={<Search />}
                  alwaysEnable
                  sx={{
                    margin: 1,
                    background: '#c5dedd',
                    color: 'rgba(10, 10, 0, 0.87)',
                    width: 0.75,
                    height: 0.65,
                    marginBottom: 6,
                    cursor: 'pointer',
                    fontSize: 17,
                  }}
                />
              </Box>
            </Stack>
          </Form>
        </Create>
      </Box>
    </>
  );
};

export default SearchFilters;
